import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const Home = () => {
  return <ListStory page={1} type="topstories" />;
};

export default Home;
